import HPSlider from './../../components/pages/home/HPSlider'

// Vue.prototype.$api = window.$api

new Vue({
  el: '#hp-slider',
  render: h => h(HPSlider)
});
